import api from './api'
import type { ApiResponse } from '@/types/api'

export interface HumanizationBufferConfig {
  read_base_s: number
  read_jitter_s: number
  ms_per_char: number
  think_prob: number
  sleep_start_h: number
  sleep_end_h: number
  sleep_multiplier: number
}

const HumanizationService = {
  async get(): Promise<HumanizationBufferConfig> {
    const response = await api.get<ApiResponse<HumanizationBufferConfig>>(
      '/api/v1/humanization/buffer',
    )
    return response.data.data
  },

  async update(data: HumanizationBufferConfig): Promise<HumanizationBufferConfig> {
    const response = await api.put<ApiResponse<HumanizationBufferConfig>>(
      '/api/v1/humanization/buffer',
      data,
    )
    return response.data.data
  },
}

export default HumanizationService
